import { useNavigate } from 'react-router-dom';

import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { toast } from 'sonner';

import { GOOGLE_CLIENT_ID, IS_DEV } from '@lemoment/shared';

import { Wordmark } from '../../../components/Wordmark';
import { useGoogleLogin } from '../hooks';

export const LoginPage = () => {
  const navigate = useNavigate();
  const login = useGoogleLogin();

  const signIn = (idToken: string) =>
    login.mutate(idToken, {
      onSuccess: () => navigate('/', { replace: true }),
      onError: () => toast.error('로그인에 실패했습니다.'),
    });

  const noAuthAvailable = !GOOGLE_CLIENT_ID && !IS_DEV;

  return (
    <div className="flex min-h-[100dvh] w-full flex-col items-center justify-center bg-background px-6 text-foreground">
      <div className="w-full max-w-sm">
        <Wordmark className="text-4xl" />
        <p className="mt-3 text-sm text-muted-foreground">
          레몬클라우드 근태 관리
        </p>

        <div className="mt-8 flex flex-col gap-4">
          {GOOGLE_CLIENT_ID ? (
            <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
              <div className="[color-scheme:light]">
                <GoogleLogin
                  onSuccess={(res) => res.credential && signIn(res.credential)}
                  onError={() => toast.error('로그인에 실패했습니다.')}
                  text="continue_with"
                  shape="pill"
                  size="large"
                  width="288"
                />
              </div>
            </GoogleOAuthProvider>
          ) : null}

          {noAuthAvailable ? (
            <p className="text-xs text-destructive">
              Google Client ID가 설정되지 않았습니다.
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
};
